import { jsx } from "react/jsx-runtime";
import { css } from "@/styled-system/css";
import { Paragraph } from "@zillow/constellation-10";
import { usePageProps, migrateColorToken, resolveTextAlign, resolveSpacing, migrateTypographyToken } from "@zillow/zrs-cms";
import { usePlacement } from "../../components/PlacementProvider/PlacementProvider.esm.js";
import makeContentInteractive from "../../util/makeSpansInteractive.esm.js";
const BlockParagraph = ({
  attrs
}) => {
  const {
    content,
    textAlign = "inherit",
    margin,
    fontType = "body",
    fontColor = "",
    marginBottom: attrMarginBottom = "default",
    marginTop: attrMarginTop,
    marginLeft: attrMarginLeft,
    marginRight: attrMarginRight
  } = attrs;
  const pageProps = usePageProps();
  const isPost = usePlacement() === "post";
  if (!content || !content.trim()) {
    return null;
  }
  const interactiveContent = makeContentInteractive(content, {
    pageProps
  });
  const effectiveMarginBottom = isPost ? "default" : (margin == null ? void 0 : margin.marginBottom) ?? attrMarginBottom;
  const effectiveMarginTop = isPost ? attrMarginTop : (margin == null ? void 0 : margin.marginTop) ?? attrMarginTop;
  const effectiveMarginLeft = (margin == null ? void 0 : margin.marginLeft) ?? attrMarginLeft;
  const effectiveMarginRight = (margin == null ? void 0 : margin.marginRight) ?? attrMarginRight;
  const scalarFontColor = typeof fontColor === "object" && fontColor !== null ? fontColor.default ?? "" : fontColor;
  const resolvedColor = scalarFontColor ? migrateColorToken(scalarFontColor) : void 0;
  const resolvedTextAlign = resolveTextAlign(textAlign);
  const resolvedMarginBottom = resolveSpacing(effectiveMarginBottom);
  const resolvedMarginTop = resolveSpacing(effectiveMarginTop);
  const resolvedMarginLeft = resolveSpacing(effectiveMarginLeft);
  const resolvedMarginRight = resolveSpacing(effectiveMarginRight);
  const cssProps = css.raw({
    color: resolvedColor ?? "inherit",
    ...resolvedMarginBottom !== void 0 && {
      marginBottom: resolvedMarginBottom
    },
    ...resolvedMarginTop !== void 0 && {
      marginTop: resolvedMarginTop
    },
    ...resolvedMarginLeft !== void 0 && {
      marginLeft: resolvedMarginLeft
    },
    ...resolvedMarginRight !== void 0 && {
      marginRight: resolvedMarginRight
    },
    ...resolvedTextAlign !== void 0 && {
      textAlign: resolvedTextAlign
    }
  });
  const scalarFontType = typeof fontType === "object" && fontType !== null ? fontType.default ?? "body" : fontType;
  const migratedTextStyle = migrateTypographyToken(scalarFontType);
  const resolvedTextStyle = typeof migratedTextStyle === "string" && migratedTextStyle.startsWith("heading-") ? "body" : migratedTextStyle;
  return /* @__PURE__ */ jsx(Paragraph, { textStyle: resolvedTextStyle, css: cssProps, children: interactiveContent });
};
export {
  BlockParagraph as default
};
